/**
//================================================================================
// ProjectName: 都営住宅募集オンライン申請
// SystemName: 都営住宅募集オンラインシステム
// JavaScriptName:browserUtility
//
// <<Modification History>>
// Version  | Date       | Updated By            | Content
// ---------+------------+-----------------------+--------------------------------
// 01.00.00 | 2021/08/17 | 富士通株式会社        | 新規作成
//================================================================================
 */
import { OSVER_WIN, OSVER_WIN_UACH, OSVER_MAC, OSVER_MAC_UACH, OSVER_ANDROID, OSVER_IOS } from '@/const/browser.js';
/*
 * ブラウザ判定
 * @return {String} ブラウザ種類
 */
export function co_getBrowser() {
    let bw;
    if ('userAgentData' in window.navigator) {
        // userAgentData が有効
        const brands = navigator.userAgentData.brands;
        for (let i = 0; i < brands.length; i++) {
            const brand = brands[i].brand.toLowerCase();

            if (brand.indexOf("google chrome") != -1) {
                bw = "google chrome"; //Google Chrome
                break;
            } else if (brand.indexOf("microsoft edge") != -1) {
                bw = "microsoft edge"; //Chromium
                break;
            } else if (brand.indexOf("safari") != -1) {
                bw = "safari";
                break;
            } else if (brand.indexOf("firefox") != -1) {
                bw = "firefox";
                break;
            } else if (brand.indexOf("opera") != -1) {
                bw = "opera";
                break;
            } else if (brand.indexOf("samsung") != -1) {
                bw = "samsung";
                break;
            } else {
                bw = "other";
                continue;
            }
        }

    } else {
        // userAgentData が無効
        const nvUA = navigator.userAgent.toLowerCase();

        if (nvUA.indexOf("msie") != -1) {
            bw = "msie"; //Old IE
        } else if (nvUA.indexOf("trident") != -1) {
            bw = "ie11";
        } else if (nvUA.indexOf("edge") != -1) {
            bw = "msedge"; //Old Edge
        } else if (nvUA.indexOf("edg") != -1) {
            bw = "microsoft edge"; //Chromium
        } else if (nvUA.indexOf("firefox") != -1) {
            bw = "firefox";
        } else if (nvUA.indexOf("opr") != -1) {
            bw = "opera";
        } else if (nvUA.indexOf("samsung") != -1) {
            bw = "samsung";
        } else if (nvUA.indexOf("safari") != -1) {
            if (nvUA.indexOf("chrome") != -1 ||
                nvUA.indexOf("crios") != -1) {
                bw = "google chrome";
            } else {
                bw = "safari";
            }
        } else {
            bw = "other";
        }
    }

    return bw;
}

/*
 * IEブラウザ判定
 * @return {boolean} IE:true IE以外:false
 */
export function co_isIE() {

    let bw = co_getBrowser();
    return (bw.indexOf("msie") != -1 || bw.indexOf("ie11") != -1);
}

/*
 * Chromeブラウザ判定
 * @return {boolean} Chrome:true Chrome以外:false
 */
export function co_isChrome() {

    let bw = co_getBrowser();
    return (bw.indexOf("microsoft edge") != -1 || bw.indexOf("google chrome") != -1);
}

/*
 * Safariブラウザ判定
 * @return {boolean} Safari:true Safari以外:false
 */
export function co_isSafari() {

    let bw = co_getBrowser();
    return (bw.indexOf("safari") != -1);
}

/*
 * OS情報取得
 * @return {String} OS種類
 */
export async function co_getOperation() {
    let os = "";
    let passIndex = -1;

    // 対象OSバージョン
    let winList = OSVER_WIN;
    let winList_userAgentData = OSVER_WIN_UACH;
    let macList = OSVER_MAC;
    let macList_userAgentData = OSVER_MAC_UACH;
    let iosList = OSVER_IOS;
    let androidList = OSVER_ANDROID;

    if ('userAgentData' in window.navigator) {
        // userAgentData が有効
        const uaData = navigator.userAgentData;
        const highEntropyValues = await uaData.getHighEntropyValues(
            ["platform", "platformVersion", "architecture", "model", "uaFullVersion"]);

        // OS情報
        const platform = highEntropyValues.platform.toLowerCase();
        // OSバージョン情報
        const platformVersion = highEntropyValues.platformVersion;

        if (platform == "windows") {
            passIndex = winList_userAgentData.findIndex(function(element) {
                return platformVersion.split('.')[0].indexOf(element) != -1;
            });
        } else if (platform == "macos") {
            passIndex = macList_userAgentData.findIndex(function(element) {
                return platformVersion.indexOf(element) != -1;
            });
        } else if (platform == "ios") {
            passIndex = iosList.findIndex(function(element) {
                return platformVersion.indexOf(element) != -1;
            });
        } else if (platform == "android") {
            passIndex = androidList.findIndex(function(element) {
                return platformVersion.indexOf(element) != -1;
            });
        }

        // if (passIndex != -1) {
        // 	os = platform + "," + platformVersion;
        // }
        os = platform + "," + platformVersion;

    } else {
        // userAgentData が無効
        const nvUA = navigator.userAgent.toLowerCase();

        if (nvUA.indexOf("windows nt") != -1) {
            passIndex = winList.findIndex(function(element) {
                return nvUA.indexOf("windows nt " + element) != -1;
            });
            if (passIndex != -1) {
                let osVer = winList[passIndex];
                if (winList[passIndex] == '6.3') {
                    osVer = 8.1;
                }
                os = "windows" + "," + osVer;
            } else {
                os = "windows,other";
            }
        } else if (nvUA.indexOf("iphone os") != -1) {
            passIndex = iosList.findIndex(function(element) {
                return nvUA.indexOf("iphone os " + element) != -1;
            });
            if (passIndex != -1) {
                os = "iphone os" + "," + iosList[passIndex];
            } else {
                os = "iphone os,other";
            }
        } else if (nvUA.indexOf("mac os x") != -1) {
            passIndex = macList.findIndex(function(element) {
                return nvUA.indexOf("mac os x " + element) != -1;
            });
            if (passIndex != -1) {
                os = "mac os x" + "," + macList[passIndex];
            } else {
                os = "mac os x,other";
            }

        } else if (nvUA.indexOf("android") != -1) {
            passIndex = androidList.findIndex(function(element) {
                return nvUA.indexOf("android " + element) != -1;
            });
            if (passIndex != -1) {
                os = "android os " + "," + androidList[passIndex];
            } else {
                os = "android os,other";
            }
        } else {
            os = "other,other";
        }
    }

    return os;
}

/*
 * システム操作可能チェック（一般利用者）
 * @return {boolean} 利用可:true 利用不可:false
 */
export async function co_isOperation() {
    let isOperation = false;
    let os = await co_getOperation();

    if (os.indexOf("windows") !== -1) {
        // Windowsの場合
        if (co_isChrome()) {
            // Windows対象ブラウザの場合
            isOperation = true;
        }

    } else if (os.indexOf("android") !== -1) {
        // Androidの場合
        if (co_isChrome()) {
            // Android対象ブラウザの場合
            isOperation = true;
        }

    } else if (os.indexOf("iphone") !== -1) {
        // iOSの場合
        if (co_isSafari()) {
            // iOS対象ブラウザの場合
            isOperation = true;
        }

    } else if (os.indexOf("mac os x") !== -1 ||
        os.indexOf("macos") !== -1) {
        // MacOSの場合
        if (co_isSafari() || co_isChrome()) {
            // MacOS対象ブラウザの場合
            isOperation = true;
        }

    } else {
        // 上記以外
        isOperation = false;
    }

    return isOperation;
}

/*
 * システム操作可能チェック（職員）
 * @return {String} OS種類
 */
export async function co_isOperationStaff() {

    let isOperation = false;
    let os = await co_getOperation();

    if (os.indexOf("windows") !== -1) {
        // Windowsの場合
        if (co_isChrome()) {
            // Windows対象ブラウザの場合
            isOperation = true;
        }
    } else {
        // 上記以外
        isOperation = false;
    }

    return isOperation;
}

/*
 * モバイルチェック
 * @return {boolean} モバイル端末か否か
 */
export async function co_isMobile() {

    let isMobile = false;
    let os = await co_getOperation();

    if (os.indexOf("android") != -1) {
        // Androidの場合
        isMobile = true;

    } else if (os.indexOf("iphone") != -1) {
        // iOSの場合
        isMobile = true;
    }

    return isMobile;
}

/*
 * OS情報取得（ブラウザエラー時の表示用）
 * @return {String} OS種類
 */
export async function co_getOperationBrowserError() {
    let os = "";
    let passIndex = -1;

    // 対象OSバージョン
    let winList = OSVER_WIN;
    let macList = OSVER_MAC;
    let iosList = OSVER_IOS;
    let androidList = OSVER_ANDROID;

    if ('userAgentData' in window.navigator) {
        // userAgentData が有効
        const uaData = navigator.userAgentData;
        const highEntropyValues = await uaData.getHighEntropyValues(
            ["platform", "platformVersion", "architecture", "model", "uaFullVersion"]);

        // OS情報
        const platform = highEntropyValues.platform.toLowerCase();
        // OSバージョン情報
        const platformVersion = highEntropyValues.platformVersion;

        os = platform + "," + platformVersion;

    } else {
        // userAgentData が無効
        const nvUA = navigator.userAgent.toLowerCase();

        if (nvUA.indexOf("windows nt") != -1) {
            passIndex = winList.findIndex(function(element) {
                return nvUA.indexOf("windows nt " + element) != -1;
            });
            if (passIndex != -1) {
                let osVer = winList[passIndex];
                if (winList[passIndex] == '6.3') {
                    osVer = 8.1;
                }
                os = "windows" + "," + osVer;
            } else {
                os = "windows,other";
            }
        } else if (nvUA.indexOf("iphone os") != -1) {
            passIndex = iosList.findIndex(function(element) {
                return nvUA.indexOf("iphone os " + element) != -1;
            });
            if (passIndex != -1) {
                os = "iphone os" + "," + iosList[passIndex];
            } else {
                os = "iphone os,other";
            }
        } else if (nvUA.indexOf("mac os x") != -1) {
            passIndex = macList.findIndex(function(element) {
                return nvUA.indexOf("mac os x " + element) != -1;
            });
            if (passIndex != -1) {
                os = "mac os x" + "," + macList[passIndex];
            } else {
                os = "mac os x,other";
            }

        } else if (nvUA.indexOf("android") != -1) {
            passIndex = androidList.findIndex(function(element) {
                return nvUA.indexOf("android " + element) != -1;
            });
            if (passIndex != -1) {
                os = "android os " + "," + androidList[passIndex];
            } else {
                os = "android os,other";
            }
        } else {
            os = "other,";
        }
    }

    return os;
}